import styled from 'styled-components'

import InlineCenterLoader from '../../../components/Loader/InlineCenterLoader'
import { media } from '../../../utils/style-utils'

const TournamentWidgetLoader = styled(InlineCenterLoader)`
  height: 24rem;
  width: 17.5rem;

  ${media.xl`
    width: 100%;
    height: 19.5;
  `}
`

export default TournamentWidgetLoader
